import { IPaginatedRequest } from '@cbgms/api'
import { ExternalSystemListResponse } from '@cbgms/api/modules/shops/external-systems'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import navigation from 'utils-support/navigation'
import { deleteExternalSystem, getExternalSystems } from './state/actions'

const ExternalSystems = () => {
  const { shopID, companyUUID } = useParams<{ shopID: string; companyUUID: string }>()
  const dispatch = useDispatch()

  const onAdd = () => {
    navigation.push(`/companies/${companyUUID}/shops/${shopID}/external-systems/new`)
  }

  const onEdit = (data: ExternalSystemListResponse) => {
    navigation.push(`/companies/${companyUUID}/shops/${shopID}/external-systems/edit/${data.System.UUID}`)
  }

  const onDelete = (externalSystem: ExternalSystemListResponse, dryRun: boolean) =>
    dispatch(deleteExternalSystem(companyUUID, shopID, externalSystem.System.UUID, dryRun))

  const loadAction = (params: IPaginatedRequest) => {
    return getExternalSystems(companyUUID, shopID, params)
  }

  return (
    <SupportListWrapper
      scope='external-systems-for-shop'
      onDelete={onDelete}
      onAdd={onAdd}
      onEdit={onEdit}
      loadAction={loadAction}
      translationKey='external-systems'
    />
  )
}

export default ExternalSystems
